import { render, staticRenderFns } from "./KartaHypotekyDetail.vue?vue&type=template&id=41df1cfe&scoped=true&"
import script from "./KartaHypotekyDetail.vue?vue&type=script&lang=js&"
export * from "./KartaHypotekyDetail.vue?vue&type=script&lang=js&"
import style0 from "./KartaHypotekyDetail.vue?vue&type=style&index=0&id=41df1cfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41df1cfe",
  null
  
)

export default component.exports